import React from 'react';
import { Col, Row } from 'react-bootstrap';
import HotelGuestReviews from './HotelGuestReviews';
import CircleRating from '../common/CircleRating';

const HotelRatings = ({ rating, ratingCount, ratingDescription, hotelId }) => {
  return (
    <Row className="mt-5 align-items-center">
      <Col md={5} className="px-0 d-flex justify-content-center">
        <CircleRating rating={rating} />
      </Col>
      <Col md={7} className="px-0">
        <h6 className="m-0">Overall Guest Score</h6>
        <h2 className="select-color m-0">{ratingDescription}</h2>
        <p className="text-muted m-0">Based on {ratingCount} Verified Guest Ratings</p>
      </Col>
      <Col md={5} className="my-4 d-flex justify-content-center">
        <HotelGuestReviews hotelId={hotelId} />
      </Col>
    </Row>
  );
};

export default React.memo(HotelRatings);
